// ** Icons Import
import { Home, Activity, ShoppingCart } from 'react-feather'

export default [
  {
    id: 'dashboards',
    title: 'Dashboards',
    navLink: '/dashboard/analytics',
    icon: <Home />
    
  }
]
